import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import useColorScheme from './useColorScheme';
import css from './DarkModeToggle.module.css';

/**
 * DarkModeToggle — sun/moon toggle button for color scheme switching.
 *
 * Usage (in Topbar):
 *   {features.darkMode && <DarkModeToggle />}
 */
const DarkModeToggle = ({ className }) => {
  const { isDark, toggle } = useColorScheme();

  return (
    <button
      type="button"
      onClick={toggle}
      className={classNames(css.toggle, isDark && css.dark, className)}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <span className={css.track}>
        <span className={css.thumb}>
          {isDark ? (
            // Moon icon
            <svg viewBox="0 0 24 24" fill="currentColor" className={css.icon}>
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
            </svg>
          ) : (
            // Sun icon
            <svg viewBox="0 0 24 24" fill="currentColor" className={css.icon}>
              <circle cx="12" cy="12" r="5"/>
              <line x1="12" y1="1" x2="12" y2="3" stroke="currentColor" strokeWidth="2"/>
              <line x1="12" y1="21" x2="12" y2="23" stroke="currentColor" strokeWidth="2"/>
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" stroke="currentColor" strokeWidth="2"/>
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" stroke="currentColor" strokeWidth="2"/>
              <line x1="1" y1="12" x2="3" y2="12" stroke="currentColor" strokeWidth="2"/>
              <line x1="21" y1="12" x2="23" y2="12" stroke="currentColor" strokeWidth="2"/>
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" stroke="currentColor" strokeWidth="2"/>
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" stroke="currentColor" strokeWidth="2"/>
            </svg>
          )}
        </span>
      </span>
    </button>
  );
};

DarkModeToggle.defaultProps = { className: null };
DarkModeToggle.propTypes = { className: string };

export default DarkModeToggle;
